module.exports = __webpack_public_path__ + "static/media/img119_R.22de5d69.jpg";